import { render, staticRenderFns } from "./CBoxChart.vue?vue&type=template&id=35935afe&scoped=true&"
import script from "./CBoxChart.vue?vue&type=script&lang=js&"
export * from "./CBoxChart.vue?vue&type=script&lang=js&"
import style0 from "./CBoxChart.vue?vue&type=style&index=0&id=35935afe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35935afe",
  null
  
)

export default component.exports